<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position:relative;">
      <v-layout wrap
        ><v-flex xs12 sm6>
          <span class="main-title">FOOD SUMMARY | &nbsp;</span>
          <span class="submain-title">Sale store report</span></v-flex
        >
        <v-flex xs12 sm6 style="display:flex;justify-content:flex-end">
          <download-excel
            :data="export_form_sale_store"
            :fields="{
              No: 'no',
              'Order code': 'order_code',
              'Order ref.': 'order_base_code',
              'Customer name': 'order_customer_full_name',
              'Rider name': 'order_rider_full_name',
              'Store name': 'store_name',
              'Item price': 'item_price',
              Transport: 'transport',
              'Extra store': 'extra_store',
              Promotion: 'promotion',
              'Com Omise 4%': 'order_com',
              Revenue: 'summary',
              Remark: 'remark',
            }"
            :name="
              'SaleStoreReport-' +
                (search_config.search_store_id == 0
                  ? 'All_store'
                  : sale_store_list.length > 0
                  ? sale_store_list[0].store_name
                  : '') +
                '_' +
                search_config.datetime_start +
                '_to_' +
                search_config.datetime_end +
                '.xls'
            "
          >
            <v-btn flat> <v-icon large color="black">print</v-icon>.xls </v-btn>
          </download-excel>
          <download-excel
            :data="export_form_sale_store"
            type="csv"
            :fields="{
              No: 'no',
              'Order code': 'order_code',
              'Order ref.': 'order_base_code',
              'Customer name': 'order_customer_full_name',
              'Rider name': 'order_rider_full_name',
              'Store name': 'store_name',
              'Item price': 'item_price',
              Transport: 'transport',
              'Extra store': 'extra_store',
              Promotion: 'promotion',
              'Com Omise 4%': 'order_com',
              Revenue: 'summary',
              Remark: 'remark',
            }"
            :name="
              'SaleStoreReport-' +
                (search_config.search_store_id == 0
                  ? 'All_store'
                  : sale_store_list.length > 0
                  ? sale_store_list[0].store_name
                  : '') +
                '_' +
                search_config.datetime_start +
                '_to_' +
                search_config.datetime_end +
                '.csv'
            "
          >
            <v-btn flat> <v-icon large color="black">print</v-icon>.csv </v-btn>
          </download-excel></v-flex
        >
      </v-layout>
    </div>
    <searchFood />
    <storeReportList />
  </div>
</template>

<script>
import searchFood from "@/components/back-office/Report/SearchBar/SearchFood";
import storeReportList from "@/components/back-office/Report/StoreReportList";
import { mapState } from "vuex";
export default {
  data() {
    return {
      items: [
        "Sort by revenue Max to Min",
        "Sort by revenue Min to Max",
        "Sort by store name",
      ],
    };
  },
  components: {
    searchFood,
    storeReportList,
  },
  destroyed() {
    this.$store.commit("fetchSaleStoreReport/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Dashboard report",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/main_dashboard",
      },
      {
        text: "Sale store report",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/report/store_report",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  computed: {
    ...mapState({
      search_config: (state) => state.fetchSaleStoreReport.clone_config_path,
      export_form_sale_store: (state) =>
        state.fetchSaleStoreReport.export_form_sale_store,
      sale_store_list: (state) => state.fetchSaleStoreReport.sale_store_list,
    }),
  },
};
</script>

<style scoped>
.main-title {
  font-size: 22px;
  font-weight: bold;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
</style>
